export const statusLabels = [
  {
    value: "",
    label: "Todos"
  },
  {
    value: "active",
    label: "Ativo"
  },
  {
    value: "blocked",
    label: "Bloqueado"
  },
  {
    value: "payment_pending",
    label: "Pagamento Pendente"
  }
]

export enum StatusEnum {
  "active" = "Ativo",
  "blocked" = "Bloqueado",
  "payment_pending" = "Pagamento Pendente"
}

export const initialPagination = {
  skip: 0,
  take: 10
}

export const initialAccountBalance = { name: "", product: "", id: "" }

export const initialBalanceList = { eventType: "", count: "" }

export const eventTypeSelectFirstLabel = { value: "", label: "Selecione um tipo de evento" }
